export const environment = {
  firebase: {
    apiKey: 'AIzaSyD3h-eiLe2Si9tPAcyEmN8U2nW7DG5GZJY',
    authDomain: 'anima-dev-c44f1.firebaseapp.com',
    projectId: 'anima-dev-c44f1',
    storageBucket: 'anima-dev-c44f1.appspot.com',
    messagingSenderId: '608183640907',
    appId: '1:608183640907:web:6b4d52a4d177ce37c03ece'
  },
  appVersion: require('../../../../package.json').version + '--dev',
  paypalId: 'ASgtjFrQt3uCwx7eTod02SLeizJkwgApotCQymMoS2PYMA0l-io-2NDtOBBUnxlkgiI1dQIwOrX9BFQq',
  production: false,
  isProd: false,
  googleClientId: '1082322181123-7rmg57kpndgiutfmetl6alaaljkbv9tu.apps.googleusercontent.com',
  googleTagId: 'GTM-TGQ3FF3',
  facebookClientId: '1',
  defaultLanguage: 'uk',
  availableLanguages: ['en', 'uk'],
  apiUrl: '/api',
  paypal: 'https://payua-sandbox.anima.help',
  liqPay: '/liqpayapi',
  notify: 'https://notify.anima.help'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
